import { Button, IconButton, Tooltip } from "@mui/material";
import { cmmsTheme } from "@setup/theme/cmms-theme";
import { ExcelIcon } from "./excel";

type Props = {
	onClick: () => void;
	disabled?: boolean;
	label?: string;
	// Filled square with just the icon, for toolbars with no room for the labelled button.
	iconOnly?: boolean;
};

export const ExcelButton = ({
	onClick,
	disabled,
	label = "EXPORT EXCEL",
	iconOnly,
}: Props) => {
	if (iconOnly) {
		return (
			// The span keeps the tooltip working while the button is disabled (a disabled button
			// fires no pointer events of its own).
			<Tooltip title={label}>
				<span>
					<IconButton
						onClick={onClick}
						disabled={disabled}
						aria-label={label}
						sx={cmmsTheme.styles.excelIconButton}
					>
						<ExcelIcon />
					</IconButton>
				</span>
			</Tooltip>
		);
	}

	return (
		<Button
			fullWidth
			variant="outlined"
			onClick={onClick}
			disabled={disabled}
			// sx, not style: the token carries hover and disabled states as nested selectors.
			sx={cmmsTheme.styles.excelButton}
		>
			{/* Filled chip: the only colored block of the button. Its background (and the grey it
			    turns when disabled) comes from the token; the icon draws in currentColor, so it
			    reads white on top. Flex + line-height 1 centers the glyph inside the chip. */}
			<span
				className="btn-icon"
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					width: 24,
					height: 24,
					borderRadius: 4,
					lineHeight: 1,
				}}
			>
				<ExcelIcon />
			</span>
			{label}
		</Button>
	);
};
